import { useState } from "react";
import { getAccessToken, postData } from "../common/MSALHelper";
import { useMsal } from "@azure/msal-react";
import "./form.css"

const DynamicForm = () => {
    
    const { instance, accounts } = useMsal();

    const [formValid, setFormValid] = useState(true);

    const [formData, setFormData] = useState({
        CallName: null,
        SaintName: null,
        LastName: null,
        MiddleName: null,
        FirstName: null,
        HNDOG_SpouseName: null,
        ChiHoi: null,
        Address: null,
        City: null,
        State: null,
        PostalCode: null,
        Country: null,
        HomePhone: null,
        WorkPhone: null,
        MobilePhone: null,
        Fax: null,
        Email: null,
        Note: null,
        Receipt: false,
        ReceiptName: null,
        ReceiptAddress: null,
        ReceiptCity: null,
        ReceiptState: null,
        ReceiptPostalCode: null,
        ReceiptCountry: null,
        ReceiptPhone: null,
        ReceiptMark: false,
        HNDOG_PLTT_Mark: false,
        HNDOG_PLTT_Date: null,
        HNDOG_PLTT_Note: null,
        HNDOG_Flag: false,
        HNDOG_PLTT: null,
        Archive: false,
        AddressInvalid: false,
        QuaDoi: false,
        NgayQuaDoi: null,
        NgayQuaDoiSpouse: null,
        TenQuaDoi: null,
        TenQuaDoiSpouse: null,
        RegistrationDate: null
    });

    // const [validity, setValidity] = useState({
    //     CallName: true,
    //     SaintName: true,
    //     LastName: true,
    //     MiddleName: true,
    //     FirstName: true,
    //     HNDOG_SpouseName: true,
    //     ChiHoi: true,
    //     Address: true,
    //     City: true,
    //     State: true,
    //     PostalCode: true,
    //     Country: true,
    //     HomePhone: true,
    //     WorkPhone: true,
    //     MobilePhone: true,
    //     Fax: true,
    //     Email: true,
    //     Note: true,
    //     Receipt: true,
    //     ReceiptName: true,
    //     ReceiptAddress: true,
    //     ReceiptCity: true,
    //     ReceiptState: true,
    //     ReceiptPostalCode: true,
    //     ReceiptCountry: true,
    //     ReceiptPhone: true,
    //     ReceiptMark: true,
    //     HNDOG_PLTT_Mark: true,
    //     HNDOG_PLTT_Date: true,
    //     HNDOG_PLTT_Note: true,
    //     HNDOG_Flag: true,
    //     HNDOG_PLTT: true,
    //     Archive: true,
    //     AddressInvalid: true,
    //     QuaDoi: true,
    //     NgayQuaDoi: true,
    //     NgayQuaDoiSpouse: true,
    //     TenQuaDoi: true,
    //     TenQuaDoiSpouse: true,
    //     RegistrationDate: true
    // });

    const fields = Object.keys(formData);

    const chunkFields = (fields, chunkSize) => {
        const chunks = [];
        for (let i = 0; i < fields.length; i += chunkSize) {
        chunks.push(fields.slice(i, i + chunkSize));
        }
        return chunks;
    };

    const fieldChunks = chunkFields(fields, 5);

    const handleChange = (event) => {
        const { name, value, type, checked } = event.target;
        const newValue = type === 'checkbox' ? checked : value;
        setFormData({ ...formData, [name]: newValue });

        // setValidity((prev) => ({
        //     ...prev,
        //     [name]: type === 'checkbox' ? checked : value.trim() !== '', // Valid if not empty or checkbox is checked
        // }));
    };

    // const validateForm = () => {
    //     // These fields are mandatory
    //     const requiredFields = ['LastName', 'FirstName', 'ChiHoi']; // List of fields that must be filled out
    
    //     // Check if all required fields are filled out (not empty or blank)
    //     const isValid = requiredFields.every((field) => formData[field]?.trim() !== '');
    //     setFormValid(isValid); // Set overall form validity
    //     return isValid;
    // };

    const handleSubmit = async (event) => {
        event.preventDefault();

        try {
            getAccessToken(instance, accounts).then(accessToken => {
                postData(accessToken, `/member/add`, f_response => {
                    if (f_response.ok) {
                        console.log('member updated successfully');
                    }
                    else console.error('Failed to update member');
                }, data => {
                    
                }, JSON.stringify(formData))
            })
        } catch (error) {
            console.error('Error updating member:', error);
        }
    };

    const getInputType = (field) => {
        const value = formData[field];
        
        if (typeof value === 'boolean') {
            return 'checkbox';
        } else if (field.includes('Date') || field.includes('NgayQuaDoi'))
        {
            return 'date';
        }
    };

    const inputStyle = (field) => ({
        padding: '10px',
        margin: '10px 0',
        borderRadius: '4px',
        outline: 'none',
        width: '100%',
    });

    const submitButtonStyle = {
        backgroundColor: formValid ? '#4CAF50' : '#ccc',
        color: 'white',
        padding: '20px 20px',
        border: 'none',
        borderRadius: '4px',
        width: '10%',
        cursor: formValid ? 'pointer' : 'not-allowed',
    };

    return <div className="form-box">
        <h2>Add Community Member</h2>
        <form id="updateForm" onSubmit={handleSubmit}>
            {fieldChunks.map((chunk, chunkIndex) => (
                <div key={chunkIndex} style={{ display: 'flex', justifyContent: 'space-evenly', marginBottom: '20px', width: '100%', }}>
                    {chunk.map((field) => (
                        <div key={field} style={{ flex: 1, marginRight: chunk.length > 1 ? '10px' : '0', }}>
                            <label>
                                {field.charAt(0).toUpperCase() + field.slice(1)}:
                                <input
                                    type={getInputType(field)} // Dynamically set input type
                                    name={field}
                                    value={formData[field]}
                                    onChange={handleChange}
                                    style={inputStyle(field)}
                                />
                            </label>
                        </div>
                    ))}
                    {chunkIndex < fieldChunks.length - 1 && <hr />} {/* <hr /> is a horizontal line for separation */}
                </div>
            ))}
            <button type="submit" style={submitButtonStyle} disabled={!formValid}>Add</button>
            {!formValid && <p style={{ color: 'red' }}>Please fill out the required fields!</p>}
        </form>
    </div>
}

export default DynamicForm;